import { SchemaAnalyticsGatewayService, SchemaIO } from '@frontend/schema';
import { demoDataUtils } from '../../../utils';

export const trendLineDemoResponse: SchemaIO<(typeof SchemaAnalyticsGatewayService)['GetTrendline']>['output'] = {
  data: demoDataUtils.generateRandomIntArray(10).map((count, index) => ({
    count,
    name: `Demo ${index + 1}`,
  })),
  message: '',
};
